import { z } from 'zod'

export const orderContractDocumentSearchSchema = z.object({
  documentId: z.coerce.number().int().positive().optional().catch(undefined)
})

export const rentalBatchContractSearchSchema = z.object({
  ids: z.preprocess(
    (value) => (Array.isArray(value) ? value.join(',') : value),
    z
      .string()
      .regex(/^\d+(,\d+){0,99}$/, '请选择 1 至 100 个租赁订单')
      .transform((value) => value.split(',').map(Number))
      .refine((ids) => ids.every((id) => Number.isSafeInteger(id) && id > 0) && new Set(ids).size === ids.length, {
        message: '租赁订单 ID 无效或重复'
      })
  )
})
